module.exports = __webpack_public_path__ + "static/media/kids_46.17dd40b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_46.jpg
// module id = 5902
// module chunks = 0